import { render, staticRenderFns } from "./FlatImport.vue?vue&type=template&id=25d448ca&scoped=true&"
import script from "./FlatImport.vue?vue&type=script&lang=js&"
export * from "./FlatImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d448ca",
  null
  
)

export default component.exports